import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import  Slider  from 'react-slick';


export default class SponsorSlider extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { browser } = this.props;
    let sponsorImage = '';

    if (browser.lessThan.tablet) {
      sponsorImage = <img src="/images/sponsors/sponsors_home_mobile.png" alt="" className="home-sponsorsItemImage" />;
    } else {
      sponsorImage = <img src="/images/sponsors/sponsors_home_desktop4.png" alt="" className="home-sponsorsItemImage" />;
    }


    var settings = {
      autoplay: false,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1
          }
        }]
    };

    return (
      <Slider {...settings}>
        <div>
            { sponsorImage }

        </div>
      </Slider>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/SponsorSlider.jsx